import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Container, Divider, Grid, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { Order, Mastercode } from 'types/schema-generated-types';
import { ORDER_DATE_FORMAT } from 'components/Orders/utils/constants';

interface CodeModalDetailsProps {
  mastercode: Mastercode | Array<Mastercode>;
  order: Order;
  isActivateCode?: boolean;
}

interface CodeModalProductInfoProps {
  mastercode: Mastercode;
  divider?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginTop: theme.spacing(2),
      fontWeight: 500
    },
    muted: {
      color: theme.palette.grey[700]
    },
    divider: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  })
);

const CodeModalProductInfo: FC<CodeModalProductInfoProps> = ({ mastercode, divider = false }) => {
  const classes = useStyles();
  const { t } = useTranslation('Order');
  return (
    <Fragment>
      <Typography className={classes.muted}>{t(`Master Code: ${mastercode.code}`)}</Typography>
      {mastercode.parentMastercode && (
        <Typography className={classes.muted}>
          {t(`Master Code: ${mastercode.parentMastercode?.code}`)}
        </Typography>
      )}
      {divider && <Divider className={classes.divider} />}
    </Fragment>
  );
};

const CodeModalDetails: FC<CodeModalDetailsProps> = ({
  order,
  mastercode,
  isActivateCode = false
}) => {
  const classes = useStyles();
  const { t } = useTranslation('Order');

  const orderDate = format(new Date(order.dateOrdered), ORDER_DATE_FORMAT);
  return (
    <Container maxWidth="sm">
      <Grid item xs={12} sm={12}>
        <Typography className={classes.title} variant="subtitle1">
          {t(isActivateCode ? 'Activate Master Code(s)' : 'Transfer Master Code(s)')}
        </Typography>
        <Typography className={classes.muted}>{t(`Order Date: ${orderDate}`)}</Typography>
        {Array.isArray(mastercode) ? (
          mastercode.map((mc, idx) => (
            <CodeModalProductInfo
              key={`single-product-info-${idx}`}
              mastercode={mc}
              divider={idx < mastercode.length - 1}
            />
          ))
        ) : (
          <CodeModalProductInfo mastercode={mastercode} />
        )}
      </Grid>
    </Container>
  );
};

export default CodeModalDetails;
